import Page from "@src/layout/Page";

export const TermsAndConditons = () => {
    return (
        <Page>
            <div data-custom-class="body">
                <h1>Terms and Conditions</h1>
                <p>
                    Here are the terms and conditions you accept to register and/or use Charsh. Please note that these terms are subject to change at any time.
                </p>

                <h2>You must be 18 years old or over</h2>
                <p>
                    While Charsh in not a social network, you can interact with others and the nature of the images any user uploads is up to them (within limits discussed in this page).
                    This means that some NSFW images may be uploaded and visible. As such, minors are not allowed to create an account and use the services provided by Charsh.
                </p>

                <h2>The material you upload must not infringe any law.</h2>
                <p>Due to the nature of the app, I accept artistic nudity.</p>
                <p>You will be permanently banned if you upload the following:
                    <ul>
                        <li>Images depicting zoophilia</li>
                        <li>NSFW images depicting underage characters</li>
                        <li>Images depicting hateful behavior, racism, bigotry, homophobia, transphobia,... </li>
                    </ul>
                    I don't even know why or how you'd come to the conclusion to use Charsh for any of this. If you can't be a decent human being, just leave.
                    I am the only judge and I reserve the right to add to this list whenever or take you down for an item that is not listed.
                </p>
                <h2>Do not steal, trace, copy other people's art.</h2>
                <p>
                    Images uploaded here are in my care. You will not use my web application for stealing other people's art.
                </p>
                <h2>Do not use the Charsh branding in unclear ways</h2>
                <p>
                    You may not use the logo and name in any way that may suggest an affiliation. Make it clear who you are and what Charsh is to you.
                    You may not use the logo and name for your own projects either.
                </p>
                <h2>Be respectful, don't harass other users</h2>
                <p>
                    The <strong>friend</strong> system setup on Charsh is meant for you to interact with <strong>friends</strong>. Do not spam. Do not abuse the invite system. Do not invite every single user.
                    You will be banned.
                </p>
                <h2>Premium subcription</h2>
                <p>
                    Your support is much appreciated but please understand that it is not refundable.
                </p>

                <p style={{ marginTop: '2rem' }}>
                    While it is not setup yet, should you wish to delete you account and all
                    data linked to it (characters and links as of right now), please contact
                    me @ <a href="mailto:support@charsh.app">support@charsh.app</a> and
                    unless I am physically unable to, I will do so within 42hours.
                </p>
            </div>
        </Page>
    );
}

